import { upperCase as up } from '@/utils'

export default {
  'ko-KR': {
    name: '한국어',
    continent: 'Asia Pacific',

    // Text.
    noMatch: '일치하는 데이터 없음',
    notFound: '아무 것도 찾을 수 없음',
    loading: '로딩',
    viewMore: '더보기',
    live: '살다',

    dashboard: '계기반',

    account: '계정',
    permission: '권한',
    view: '조회 수',
    camera: '카메라',

    updated: '마지막 업데이트',
    logined: '마지막 로그인',
    registered: '등록일',

    // Errors messages.
    errors: {
      _default  : (field: any) => `${up(field)}항목의 값이 유효하지 않습니다.`,
      alpha     : (field: any) => `${up(field)}항목에는 영문자만 사용 가능합니다.`,
      alpha_num : (field: any) => `${up(field)}항목에는 영문자와 숫자만 사용 가능합니다.`,
      confirmed : (field: any) => `${up(field)}항목의 값이 일치하지 않습니다.`,
      email     : (field: any) => `${up(field)}항목의 값은 유효한 이메일 형식이어야 합니다.`,
      max       : (field: any, [length]: any) => `${up(field)}항목의 값은 최대 ${length}글자이어야 합니다.`,
      min       : (field: any, [length]: any) => `${up(field)}항목의 값은 최소 ${length}글자이어야 합니다.`,
      required  : (field: any) => `${up(field)}항목은 필수 정보입니다.`
    }
  }
}